// 保険外の内訳計算
const handleAtCostBeServiceUnitsSet = (
  atCost: { [key: string]: string | number }[]
) => {
  if (atCost.length === 0) return
  atCost.forEach((obj: { [key: string]: string | number }) => {
    obj.sum = Number(obj.beCount) * Number(obj.units)
  })
}

// 保険外の合計計算
const handleAtCostSummarySet = (
  atCost: { [key: string]: string | number }[]
) => {
  if (atCost.length === 0) return ''
  const atCostFilterArray = atCost.filter(
    (obj: { [key: string]: string | number }) => obj.sum
  )

  if (atCostFilterArray.length !== 0) {
    let atCostSummary = 0
    atCostFilterArray.forEach((obj: { [key: string]: string | number }) => {
      atCostSummary += Number(obj.sum)
    })

    return atCostSummary
  } else {
    return ''
  }
}

// 請求合計計算
const handleTotalCostSet = (data: any) => {
  let batDecisionUbCost = 0
  let atCostSummary = 0

  if (data.batDecisionUbCost) {
    batDecisionUbCost = data.batDecisionUbCost
  }

  if (data.atCostSummary) {
    atCostSummary = data.atCostSummary
  }

  const billingAmount = Number(batDecisionUbCost) + Number(atCostSummary)

  return billingAmount
}

const sumCommonKeys = (array: { [key: string]: string }[]) => {
  const result: { [key: string]: number } = {};

  // 最初のオブジェクトをベースにして足し算を行う
  for (const key in array[0]) {
    if (array.every(obj => Object.prototype.hasOwnProperty.call(obj, key)) && key === 'sum') {
      result[key] = array.reduce((sum, obj) => sum + Number(obj[key]), 0);
    }
  }

  return result;
}

// 消費税の内訳計算
const handleAtCostSummaryTaxSet = (
  atCost: { [key: string]: string | number }[]
) => {
  console.log(atCost)
  const object = {
    nonTaxable: 0,
    taxableAtTenExcludingTax: 0,
    tenConsumptionTax: 0,
    taxableAtEightExcludingTax: 0,
    eightConsumptionTax: 0,
  } as { [key: string]: number }

  if (atCost.length === 0) return object

  const taxableAtTen = sumCommonKeys(atCost.filter(obj => obj.tax === '1.1') as { [key: string]: string }[]).sum
  const taxableAtEight = sumCommonKeys(atCost.filter(obj => obj.tax === '1.08') as { [key: string]: string }[]).sum

  object.nonTaxable = (sumCommonKeys(atCost.filter(obj => obj.tax === '1') as { [key: string]: string }[]).sum ?? 0) + (sumCommonKeys(atCost.filter(obj => !obj.tax) as { [key: string]: string }[]).sum ?? 0)
  object.taxableAtTenExcludingTax = taxableAtTen != undefined ? Math.round(taxableAtTen / 1.1) : 0
  object.tenConsumptionTax = object.taxableAtTenExcludingTax == 0 ? 0 : taxableAtTen - object.taxableAtTenExcludingTax
  object.taxableAtEightExcludingTax = taxableAtEight != undefined ? Math.round(taxableAtEight / 1.08) : 0
  object.eightConsumptionTax = object.taxableAtEightExcludingTax == 0 ? 0 : taxableAtEight - object.taxableAtEightExcludingTax

  return object
}

export const valueResetSet = (state: any) => {
  state.data = {}
}

export const valueSet = (state: any, value: any) => {
  const setData: any = {}

  Object.keys(value).forEach(key => {
    if (value[key] !== null && value[key] !== undefined) {
      setData[key] = value[key]
    }
  })
  handleAtCostBeServiceUnitsSet(setData.atCost)
  setData.atCostSummary = handleAtCostSummarySet(setData.atCost)

  setData.billingAmount = handleTotalCostSet(setData)

  setData.atCostTaxSummaryObject = handleAtCostSummaryTaxSet(setData.atCost)

  state.data = setData
}

export const valueTargeSet = (state: any, value: any) => {
  state.data[value.key] = value.value
  handleAtCostBeServiceUnitsSet(state.data.atCost)
  state.data.atCostSummary = handleAtCostSummarySet(state.data.atCost)
  state.data.billingAmount = handleTotalCostSet(state.data)

  state.data.atCostTaxSummaryObject = handleAtCostSummaryTaxSet(state.data.atCost)
}

export const valueTargeArraySet = (state: any, value: any) => {
  state.data[value.key][value.idx] = value.item

  const tmpArray = JSON.parse(JSON.stringify(state.data[value.key]))

  state.data[value.key].splice(-state.data[value.key].length)

  state.data[value.key].push(...tmpArray)
  handleAtCostBeServiceUnitsSet(state.data.atCost)
  state.data.atCostSummary = handleAtCostSummarySet(state.data.atCost)
  state.data.billingAmount = handleTotalCostSet(state.data)

  state.data.atCostTaxSummaryObject = handleAtCostSummaryTaxSet(state.data.atCost)
}

export const atCostAddItem = (state: any) => {
  state.data.atCost.push({
    item: '',
    units: '',
    beCount: '',
    sum: '',
    tax: '1',
  })

  handleAtCostBeServiceUnitsSet(state.data.atCost)
  state.data.atCostSummary = handleAtCostSummarySet(state.data.atCost)
  state.data.billingAmount = handleTotalCostSet(state.data)

  state.data.atCostTaxSummaryObject = handleAtCostSummaryTaxSet(state.data.atCost)
}

export const atCostremoveItem = (state: any, index: number) => {
  state.data.atCost.splice(index, 1)

  handleAtCostBeServiceUnitsSet(state.data.atCost)
  state.data.atCostSummary = handleAtCostSummarySet(state.data.atCost)
  state.data.billingAmount = handleTotalCostSet(state.data)

  state.data.atCostTaxSummaryObject = handleAtCostSummaryTaxSet(state.data.atCost)
}

export const atCostSetTaxSummary = (atCost: { [key: string]: string | number }[]) => {
  return handleAtCostSummaryTaxSet(atCost)
}
